import React, { useEffect, useState } from 'react'

import { push } from 'connected-react-router'
import { useDispatch } from 'react-redux'

import { Button, H1, P, Span } from '@driftt/tide-core'

import AllowNotificationsExplainer from 'images/allow-notifications-explainer.png'
import { page, track } from 'utils/trackingUtils'

import './style.css'

const NotificationsStep = () => {
  const dispatch = useDispatch()
  const [isRequesting, setIsRequesting] = useState(false)
  const [pageState, setPageState] = useState('request')

  useEffect(() => {
    page('Unified Seat Notifications')
  }, [])

  const onContinue = () => {
    dispatch(push('/invite/personalize'))
  }

  const skipPermissions = () => {
    track('Unified Seat Notifications Selection', {
      permission: 'skipped',
    })
    onContinue()
  }

  const requestPermission = () => {
    setIsRequesting(true)
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        track('Unified Seat Notifications Selection', {
          permission: 'granted',
        })
        onContinue()
      } else {
        setIsRequesting(false)
        setPageState('denied')
        track('Unified Seat Notifications Selection', {
          permission: 'denied',
        })
      }
    })
  }

  return (
    <>
      <H1>Allow notifications from Drift</H1>
      <P>
        Notifications let you engage with prospects and target accounts as soon
        as they hit your site or start a chat. Allow them so that you don’t miss
        any important activity.
      </P>
      <img
        className="allow-notifications-image"
        src={AllowNotificationsExplainer}
        alt="notification-permission-modal"
      />
      <P>
        Click “allow notifications” then follow the browser prompts to continue.
      </P>
      {pageState === 'request' && (
        <Button
          className="allow-notifications-button"
          loading={isRequesting}
          onClick={requestPermission}
        >
          Allow notifications
        </Button>
      )}
      {pageState === 'denied' && (
        <strong>
          That&rsquo;s okay! You can always enable notifications later.
        </strong>
      )}
      <Span className="skip-notifications" onClick={skipPermissions}>
        Skip for now
      </Span>
    </>
  )
}

export default NotificationsStep
